export const DATE_FORMAT_BLOG_EN = 'MMM D, YYYY' as const;

export const DATE_FORMAT_BLOG_HR = 'D. MMM YYYY.' as const;
